import React, { useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';
import lenis from '../lenis';

function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleScrollTo = (target) => {
    const scrollOptions = { offset: 0 };
    setOpen(false);

    if (location.pathname === '/') {
      lenis.scrollTo(target, scrollOptions);
    } else {
      navigate('/', { state: { scrollToId: target, scrollOptions } });
    }
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-[#191919]">
      <div className="max-w-7xl mx-auto flex justify-between items-center px-4 sm:px-6 md:px-8 py-3 sm:py-4">

        {/* LOGO */}
        <img
          src={logo}
          alt="Logo de Kifli"
          className="h-10 sm:h-12 md:h-[55px] w-auto cursor-pointer shrink-0"
          onClick={() => handleScrollTo('#inicio')}
        />

        {/* LINKS DESKTOP */}
        <ul className="hidden md:flex space-x-10 text-base lg:text-lg text-lime-400/60">
          <li><button onClick={() => handleScrollTo('#calculadora')} className="hover:text-white font-semibold">Calculadora</button></li>
          <li><button onClick={() => handleScrollTo('#como-funciona')} className="hover:text-white font-semibold">Cómo Funciona</button></li>
          <li><button onClick={() => handleScrollTo('#nosotros')} className="hover:text-white font-semibold">Nosotros</button></li>
          <li><button onClick={() => handleScrollTo('#faq')} className="hover:text-white font-semibold">FAQs</button></li>
        </ul>

        {/* ACCIONES */}
        <div className="hidden md:flex items-center gap-4">
          {user ? (
            <>
              {user.role === 'admin' && (
                <RouterLink to="/admin" className="hover:text-cyan-400 font-semibold">
                  Admin
                </RouterLink>
              )}
              <RouterLink to="/mis-pedidos" className="hover:text-lime-400 font-semibold">
                Mis pedidos
              </RouterLink>
              <RouterLink to="/datos-de-envio" className="hover:text-lime-400 font-semibold">
                Datos de envío
              </RouterLink>
              <button
                onClick={logout}
                className="border border-white text-white text-xs lg:text-sm font-bold px-4 py-2 rounded-full hover:bg-white hover:text-black transition"
              >
                Cerrar sesión
              </button>
            </>
          ) : (
            <>
              <RouterLink
                to="/ingresar"
                className="border border-lime-400 text-white text-xs lg:text-sm font-bold px-4 py-2 rounded-full hover:bg-white hover:text-lime-400 transition"
              >
                Ingresar
              </RouterLink>
              <RouterLink
                to="/crear-cuenta"
                className="bg-lime-400 text-black text-xs lg:text-sm font-bold px-4 py-2 rounded-full hover:bg-white transition"
              >
                Crear cuenta
              </RouterLink>
            </>
          )}
        </div>

        {/* BOTÓN HAMBURGUESA (mobile) */}
        <button
          className="md:hidden text-white text-2xl"
          onClick={() => setOpen(!open)}
        >
          ☰
        </button>
      </div>

      {/* MENU MOBILE */}
        {open && (
          <div className="md:hidden bg-[#111111] px-6 pb-6 space-y-4 text-center">
        
            {/* SECCIONES */}
            {['calculadora', 'como-funciona', 'nosotros', 'faq'].map((id) => (
              <button
                key={id}
                onClick={() => handleScrollTo(`#${id}`)}
                className="block w-full text-gray-300 text-base font-semibold hover:text-lime-400"
              >
                {id.replace('-', ' ').toUpperCase()}
              </button>
            ))}
        
            {/* 🔥 LINKS DE USUARIO */}
            {user && (
              <div className="pt-4 border-t border-[#333] space-y-3">
                {user.role === 'admin' && (
                  <RouterLink
                    to="/admin"
                    onClick={() => setOpen(false)}
                    className="block w-full text-cyan-400 font-semibold"
                  >
                    Admin
                  </RouterLink>
                )}
        
                <RouterLink
                  to="/mis-pedidos"
                  onClick={() => setOpen(false)}
                  className="block w-full text-lime-400 font-semibold"
                >
                  Mis pedidos
                </RouterLink>
        
                <RouterLink
                  to="/datos-de-envio"
                  onClick={() => setOpen(false)}
                  className="block w-full text-lime-400 font-semibold"
                >
                  Datos de envío
                </RouterLink>
              </div>
            )}
        
            {/* ACCIONES */}
            <div className="pt-4 space-y-3">
              {user ? (
                <button
                  onClick={() => {
                    logout();
                    setOpen(false);
                  }}
                  className="w-full border border-white text-white py-2 rounded-full text-sm"
                >
                  Cerrar sesión
                </button>
              ) : (
                <>
                  <RouterLink
                    to="/ingresar"
                    onClick={() => setOpen(false)}
                    className="block w-full border border-lime-400 text-white py-2 rounded-full text-sm"
                  >
                    Ingresar
                  </RouterLink>
        
                  <RouterLink
                    to="/crear-cuenta"
                    onClick={() => setOpen(false)}
                    className="block w-full bg-lime-400 text-black py-2 rounded-full text-sm"
                  >
                    Crear cuenta
                  </RouterLink>
                </>
              )}
            </div>
          </div>
        )}
    </nav>
  );
}

export default Navbar;
